import request from './request'

export const feedbackApi = {
  listFeedback (params) {
    return request.get('/feedbacks', { params: params })
  },
  saveFeedback (data) {
    return request.post('/feedback', data)
  },
  deleteFeedback (id) {
    return request.delete('/feedbacks/' + id)
  },
  getFeedback (id) {
    return request.get('/feedbacks/' + id)
  },
  updateFeedback (id, data) {
    return request.put('/feedbacks/' + id, data)
  },
}

export default feedbackApi
